import StudentModuleProgress from './StudentModuleProgress';

export default StudentModuleProgress;
